import React from "react";
import { generateTourPDFCSS } from "../../../../controllers/cssController";
import AccountStatementPDFHeaderStatic from "./AccountStatementPDFHeaderStatic";
import AccountStatementPDFTableSectionStatic from "./AccountStatementPDFTableSectionStatic";
import AccountStatementPDFFooterStatic from "./AccountStatementPDFFooterStatic";

function AccountStatementPDFSection({ data }) {
  const accountStatementHeader = AccountStatementPDFHeaderStatic(data);
  const accountStatementTable = AccountStatementPDFTableSectionStatic(data);
  const accountStatementFooter = AccountStatementPDFFooterStatic(data);

  const combinedStaticMarkup = `
      <div class="flex flex-col gap-4">
        ${accountStatementHeader}
        ${accountStatementTable}
        ${accountStatementFooter}
      </div>
    `;
  // ${tourSectionStatic}
  // ${tourDetailSectionStatic}
  // ${travellerSectionStatic}
  return (
    <div className="tour-doc-template">
      <div dangerouslySetInnerHTML={{ __html: combinedStaticMarkup }} />
      <style>{generateTourPDFCSS()}</style>
    </div>
  );
}

export default AccountStatementPDFSection;
